import css from 'styled-jsx/css';

const styles = css.global`#canais-atendimento-telefones {
    position: relative;
    display: none;
}

#canais-atendimento-telefones.show {
    display: block;
    background: #FBFBFB;
    overflow: hidden;
}

#canais-atendimento-telefones .ctn-home-24,
#canais-atendimento-telefones .ctn-home-24 .telefones-canais,
#canais-atendimento-telefones .ctn-home-24 .telefones-fgts {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

#canais-atendimento-telefones .ctn-home-24 .telefones-canais {
    position: relative;
}

#canais-atendimento-telefones .telefones-content {
    display: flex;
    flex-direction: column;
    gap: 40px;
    position: relative;
        z-index: 101;
}

#canais-atendimento-telefones .telefone-bloco {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

#canais-atendimento-telefones .telefone-bloco .telefones-title {
    margin: 0;
    color: #C00;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px;
}

#canais-atendimento-telefones .telefones-fgts .telefone-bloco .telefones-title {
    color: #222;
}

#canais-atendimento-telefones .telefones-fgts .telefone-bloco .telefones-title.title-fgts {
    margin-bottom: 16px;
}

#canais-atendimento-telefones .telefone-bloco .telefones-paragrafo {
    color: #222;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#canais-atendimento-telefones .telefone-bloco .telefone-numero {
    display: flex;
    align-items: baseline;
    gap: 4px;
    flex-wrap: wrap;
}

#canais-atendimento-telefones .telefone-bloco .telefone-numero a {
    color: #222;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    text-decoration: underline;
}

#canais-atendimento-telefones .telefone-bloco .telefone-numero a:hover {
    color: #cc0000;
}

#canais-atendimento-telefones .telefone-bloco .telefone-numero .tel-parenteses {
    color: #222;
    font-family: "SantanderMicroText";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
}

#canais-atendimento-telefones .telefone-bloco .telefone-numero .libras-disclaimer {
    color: #222;
    font-family: "SantanderHeadlineIt";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
}

#canais-atendimento-telefones .img-celular {
    max-width: 280px;
    margin: 7px auto 0;
}

#canais-atendimento-telefones .logo-santander {
    position: absolute;
    bottom: 0;
    right: -140px;
    width: 580px;
}

@media (min-width: 992px) {
    #canais-atendimento-telefones.show {
        overflow: visible;
    }
    #canais-atendimento-telefones .ctn-home-24 {
        gap: 56px;
    }
    #canais-atendimento-telefones .ctn-home-24 .telefones-canais{
        flex-direction: row;
        justify-content: space-between;
        padding-bottom: 96px;
    }

    #canais-atendimento-telefones .telefones-content {
        max-width: 650px;
        
    }
    #canais-atendimento-telefones .telefones-content .only-mobi {
        display: none;
    }
    #canais-atendimento-telefones .telefone-bloco .telefone-numero a {
        font-size: 24px;
        line-height: 32px;
    }

    #canais-atendimento-telefones .telefone-bloco .telefone-numero.link-sac a {
        font-size: 23px;
        line-height: 32px;
    }
    
    #canais-atendimento-telefones .telefone-bloco .telefone-numero .tel-parenteses {
        font-size: 18px;
        line-height: 28px;
    }

    #canais-atendimento-telefones .img-celular {
        max-width: 323px;
        margin: auto 40px;
        position: relative;
        z-index: 3;
    }

    #canais-atendimento-telefones .logo-santander {
        position: absolute;
        bottom: 0;
        right: 0;
        /* z-index: 100; */
        width: 100%;
        max-width: 870px;
    }
}`;

export default styles;